import { FileToUpload } from './filetoupload';
import { OnboardVrifications } from './OnboardVrifications';
import { OnboardEmpDoc } from './OnboardEmpDoc';

export class OnboardEmployeePassportVisaInfo {
  onboardPassport: OnboardEmpDoc[];
  onboardVisas: OnboardEmpDoc[];
  onboardVrifications: OnboardVrifications = new OnboardVrifications();
}
